export default __webpack_public_path__ + "static/media/sticker-wi.326203cf.png";